import 'css-chunksrc/client/scenes/calendar/weeklyView/timeView/unavailability/styles.scss';export default {
  "unavailability": "_unavailability_q10f0_1",
  "background": "_background_q10f0_17",
  "leftBorder": "_leftBorder_q10f0_26",
  "main": "_main_q10f0_36",
  "short": "_short_q10f0_47",
  "name": "_name_q10f0_52",
  "time": "_time_q10f0_58",
  "icon": "_icon_q10f0_79"
};